import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const leaveManagement = {
	// 修改请假
	modifyLeave(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/leave/admin/modify`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 新增请假
	addLeave(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/leave/admin/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	list(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/leave/admin/list`,
			headers: config.headers,
			params
		});
	},
	// 详情
	info(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/leave/admin/info`,
			headers: config.headers,
			params
		});
	},
	delete(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/leave/admin/delete`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	getLeaveRecord(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/leave/list/record`,
			params
		});
	},
	verifyLeave(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/leave/verify`,
			data: qs.stringify(data)
		});
	},
	revokeLeave(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/leave/revoke`,
			data: qs.stringify(data)
		});
	}
};
export default leaveManagement;
